/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { ProductNumberThumbnail } from './ProductNumberThumbnail';
import {
    ProductNumberThumbnailFromJSON,
    ProductNumberThumbnailFromJSONTyped,
    ProductNumberThumbnailToJSON,
    ProductNumberThumbnailToJSONTyped,
} from './ProductNumberThumbnail';
import type { TrackingShipmentProjection } from './TrackingShipmentProjection';
import {
    TrackingShipmentProjectionFromJSON,
    TrackingShipmentProjectionFromJSONTyped,
    TrackingShipmentProjectionToJSON,
    TrackingShipmentProjectionToJSONTyped,
} from './TrackingShipmentProjection';

/**
 * 
 * @export
 * @interface CurrentInvoiceSummary
 */
export interface CurrentInvoiceSummary {
    /**
     * 
     * @type {string}
     * @memberof CurrentInvoiceSummary
     */
    id: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof CurrentInvoiceSummary
     */
    number: HeoTransactionNumber;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof CurrentInvoiceSummary
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {string}
     * @memberof CurrentInvoiceSummary
     */
    cityShippedTo: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentInvoiceSummary
     */
    zipCodeShippedTo: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentInvoiceSummary
     */
    filed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentInvoiceSummary
     */
    canceled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CurrentInvoiceSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {Array<TrackingShipmentProjection>}
     * @memberof CurrentInvoiceSummary
     */
    shipments: Array<TrackingShipmentProjection>;
    /**
     * 
     * @type {Array<ProductNumberThumbnail>}
     * @memberof CurrentInvoiceSummary
     */
    productItems: Array<ProductNumberThumbnail>;
}

/**
 * Check if a given object implements the CurrentInvoiceSummary interface.
 */
export function instanceOfCurrentInvoiceSummary(value: object): value is CurrentInvoiceSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('cityShippedTo' in value) || value['cityShippedTo'] === undefined) return false;
    if (!('zipCodeShippedTo' in value) || value['zipCodeShippedTo'] === undefined) return false;
    if (!('filed' in value) || value['filed'] === undefined) return false;
    if (!('canceled' in value) || value['canceled'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('shipments' in value) || value['shipments'] === undefined) return false;
    if (!('productItems' in value) || value['productItems'] === undefined) return false;
    return true;
}

export function CurrentInvoiceSummaryFromJSON(json: any): CurrentInvoiceSummary {
    return CurrentInvoiceSummaryFromJSONTyped(json, false);
}

export function CurrentInvoiceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentInvoiceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': HeoTransactionNumberFromJSON(json['number']),
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'cityShippedTo': json['cityShippedTo'],
        'zipCodeShippedTo': json['zipCodeShippedTo'],
        'filed': json['filed'],
        'canceled': json['canceled'],
        'createdAt': (new Date(json['createdAt'])),
        'shipments': ((json['shipments'] as Array<any>).map(TrackingShipmentProjectionFromJSON)),
        'productItems': ((json['productItems'] as Array<any>).map(ProductNumberThumbnailFromJSON)),
    };
}

export function CurrentInvoiceSummaryToJSON(json: any): CurrentInvoiceSummary {
    return CurrentInvoiceSummaryToJSONTyped(json, false);
}

export function CurrentInvoiceSummaryToJSONTyped(value?: CurrentInvoiceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': HeoTransactionNumberToJSON(value['number']),
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'cityShippedTo': value['cityShippedTo'],
        'zipCodeShippedTo': value['zipCodeShippedTo'],
        'filed': value['filed'],
        'canceled': value['canceled'],
        'createdAt': value['createdAt'].toISOString(),
        'shipments': ((value['shipments'] as Array<any>).map(TrackingShipmentProjectionToJSON)),
        'productItems': ((value['productItems'] as Array<any>).map(ProductNumberThumbnailToJSON)),
    };
}

